
export default {
  props: {
    /* Note: we used to support collapsible properties,
      commit assoc. with this comment removes this functionality */
    idPrefix: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: null,
    },
    // jw: array of objects in structure {'id', 'text'}
    properties: {
      type: Array,
      required: true,
    },
  },
};
